<template>
  <div class="i-search">
    <search-select
      v-model="inputValue"
      :placeholder="$t('searchContent')"
      :value="searchKeywords"
      :options="combineSearchResult"
      :option-format="{valueKey: 'name', textKey: 'name'}"
      :icon-behavior="'submit'"
      type="searchKeywords"
      @input="onInput"
      @submit="onSubmit"
      @select="onSubmit"
    >
      <svg-icon
        slot="icon"
        class="icon"
        name="search"
        color="#EC0A74"
        @click="isTaiwantrade ? onSubmit : null"
      />
    </search-select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SvgIcon from '../components/SvgIcon/index.vue'
import SearchSelect from './SearchSelect.vue'
import { COMPANY } from '~js/constants'

export default {
  components: {
    SvgIcon,
    SearchSelect
  },
  data () {
    return {
      inputValue: ''
    }
  },
  computed: {
    ...mapGetters([
      'mainColor',
      'krpanoEl',
      'panoramas',
      'currentPanorama',
      'krpanoXOffset',
      'searchKeywords',
      'combineSearchResult',
      'user'
    ]),
    isTaiwantrade () {
      return this.user.headquarter.title === COMPANY.TAIWANTRADE
    }
  },
  methods: {
    ...mapActions([
      'closeInformation',
      'closeShare',
      'closeMarkerInfo',
      'closeLocation',
      'selectPanorama',
      'stopAutoRotate',
      'showSearchs',
      'closeSearchs',
      'closeComments',
      'setSearchKeywords'
    ]),
    onInput (val) {
      if (this.isTaiwantrade) {
        if (!val) {
          this.setSearchKeywords(this.inputValue)
        }
      } else {
        this.setSearchKeywords(val)
      }
    },
    onSubmit () {
      if (this.isTaiwantrade) {
        this.setSearchKeywords(this.inputValue)
      }
      this.showSearchs()
      this.closeInformation()
      this.closeShare()
      this.closeMarkerInfo()
      this.closeLocation()
      this.closeComments()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/common/extends'
@import '~css/addon/main'
.i-search {
  width: 100%;
  position: relative;
  display: flex;

  .icon {
    margin-top: 11px;
    margin-right: 5px;// (.i-select-input height - 24) / 2
  }
}
</style>
